export const SOFTLINE_PERMISSION_TIMESTAMP = 'STEMPELERFASSUNG';
export const SOFTLINE_PERMISSION_TIMESTAMP_CUSTOM = 'STEMPELERFASSUNG.EDIT';
export const SOFTLINE_PERMISSION_TIMESTAMP_SELECT_EMPLOYEE =
  'STEMPELERFASSUNG.SUPERUSER';
